import { PATHS } from 'consts/paths';
import { isLogged } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect } from 'react';
import useSWR from 'swr';

export function useAMLStatus() {
	const { config, state, navigate } = useContext(AppContext);
	const { user } = state;
	const url = isLogged(user) ? `${config.API.getAMLStatus}/${user.kennitala}` : null;
	const { data } = useSWR(url);

	useEffect(() => {
		if (data) {
			const { isAmlRenewalRequired, hasFinishedAml } = data;
			const page = isAmlRenewalRequired || !hasFinishedAml ? PATHS.AML : PATHS.ONBOARD;
			navigate(`/${user.flowType}/${user.entityType}/${page}`);
		}
	}, [data, navigate, user.flowType, user.entityType]);
}
